import { QueryClient } from '@tanstack/react-query'
import { fetchPage } from '@vangst/services/oogst/page'
import { RobotsEnum } from '@vangst/services/oogst/types'
import Routes from '@vangst/services/routes'
import { InferGetStaticPropsType } from 'next'
import Breadcrumbs from '../../components/navigation/Breadcrumbs'
import Markdown from '../../components/views/Markdown'
import PageHeader from '../../components/views/PageHeader'
import Meta from '../../domains/application/Meta'

export async function getStaticProps() {
  const fs = require('fs')
  const path = require('path')
  const file = path.join('./cms/', 'standard-terms.md')
  const markdown = fs.readFileSync(file, 'utf-8')

  const queryClient = new QueryClient()
  const rawUrl = __filename.split('pages')[1]?.replace('.js', '')
  const { getPage } = await fetchPage(queryClient, { rawUrl })
  const page = {
    ...getPage,
    title:
      getPage?.title ?? 'Vangst Standard Terms and Conditions for Services',
  }
  const crumbs = [
    { href: Routes.INDEX, text: 'Home' },
    { href: Routes.LEGAL, text: 'Legal' },
    { href: null, text: 'Standard Terms and Conditions For Services' },
  ]

  return {
    props: { crumbs, markdown, page },
  }
}

// -------------------------------------

type PropsType = InferGetStaticPropsType<typeof getStaticProps>

export default function StandardTermsPage(props: PropsType) {
  const { crumbs, markdown, page } = props

  return (
    <>
      <Meta
        key="meta"
        canonicalUrl={page.metaInfo?.canonicalUrl}
        crumbs={crumbs}
        description={page.metaInfo?.description}
        image={page.pagePhotos?.[0]?.url}
        publishDate={page.postedAt}
        robots={page.metaInfo?.robots ?? RobotsEnum.IndexFollow}
        title={page.metaInfo?.title ?? page.title}
      />
      <Breadcrumbs crumbs={crumbs} />
      <article className="mood-white">
        <PageHeader
          title={page.title}
          subtitle={page.subtitle}
          description={page.description}
          imgAlt={page.pagePhotos?.[0]?.alt}
          imgSrc={page.pagePhotos?.[0]?.url}
        />
        <section className="contain-xyc">
          <Markdown className="max-w-6xl">{markdown}</Markdown>
        </section>
      </article>
    </>
  )
}
